import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Modal,
  Tag,
  Popconfirm,
  Divider,
  Row,
  Col,
  Form,
  Select,
} from "antd";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTestSearchText,
//   ChangeConsultatationTableData,
//   ChangeTestDetailsModalState,
// } from "../../../actions/trainerAction";
import { changeTestSearchText } from "../../../reducers/trainer";
import "./index.css";
import moment from "moment";
import UploadIcon from "../../../assets/fileUpload.svg";
import {
  SecureDelete,
  SecurePost,
  SecurePostMultipart,
} from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";
import {
  givenEnglishTopics,
  givenLevels,
  givenMathsTopics,
  givenScienceTopics,
} from "../../common/constants";
import { retriveToken } from "../../../services/AuthServices";
import {
  DeleteOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { fetchConsultationTableData } from "../../../features/trainerAsync";

const { Title } = Typography;
const { Option } = Select;

const QuestionConsultation = () => {
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [question, setQuestion] = useState({});
  const [file, setFile] = useState(null);
  const [values, setValues] = useState({});
  const [form] = Form.useForm();
  const searchInput = useRef();

  const dispatch = useDispatch();
  const { ConsultationTabelData, loading, TestsearchText } = useSelector(
    (state) => state.trainer
  );

  // console.log("Data,", ConsultationTabelData,loading,TestsearchText);

  useEffect(() => {
    dispatch(fetchConsultationTableData());
  }, [dispatch]);

  const openModal = (obj) => {
    setQuestion(obj);
    setIsModelOpen(true);
  };

  const closeModal = () => {
    setIsModelOpen(false);
    form.resetFields();
    setFile(null);
    setValues({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleTopicChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value.value }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.startsWith("video/")) {
      setFile(selectedFile);
    } else {
      Alert("warning", "Message", "Please select a valid video file.");
    }
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeTestSearchText(selectedKeys[0]));
  };

  const handleReset = (clearFilters, confrim) => {
    clearFilters();
    confrim();
    dispatch(changeTestSearchText(""));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[TestsearchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ""}
      />
    ),
  });

  const getColumnDateSearchProps = (dataIndex) => ({
    ...getColumnSearchProps(dataIndex),
    onFilter: (value, record) =>
      moment(record[dataIndex]).format("DD/MM/YYYY").includes(value),
  });

  const deleteTest = (id) => {
    SecurePost({
      url: apis.DELETE_CONSLTATION_QUESTION,
      data: { _id: id },
    })
      .then((response) => {
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchConsultationTableData());
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        Alert(
          "error",
          "Error!",
          error.response?.data?.message || error.message
        );
      });
  };

  const handleSubmitResponse = () => {
    form.validateFields().then(() => {
      const t = retriveToken();
      if (!file) return Alert("warning", "Message", "Please Upload Video");

      const formData = new FormData();
      formData.append("video", file);
      formData.append("learningOutcomes", values.learningOutcomes);
      formData.append("questionTopic", values.questionTopic);
      formData.append("requestId", question._id);

      if (t && t !== "undefined") {
        submitConsultationResponse(t, formData);
      } else {
        window.location = "/";
      }
    });
  };

  const submitConsultationResponse = (t, data) => {
    SecurePostMultipart({
      url: apis.SUBMIT_CONSLTATION_QUESTION_RESPONSE,
      params: { Token: t },
      data,
    })
      .then((response) => {
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchConsultationTableData());
          closeModal();
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        Alert(
          "error",
          "Error!",
          error.response?.data?.message || error.message
        );
      });
  };

  const nameColumnSearchProps = getColumnSearchProps("name");
  const subjectColumnSearchProps = getColumnSearchProps("subject");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.title > b.title,
      ...nameColumnSearchProps,
      render: (text) => {
        const defaultRendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;

        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Subject</span>,
      dataIndex: "subject",
      key: "subject",
      ...subjectColumnSearchProps,
      render: (text) => {
        const defaultRendered = subjectColumnSearchProps.render
          ? subjectColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{defaultRendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Created on</span>,
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => a.createdAt > b.createdAt,
      ...getColumnDateSearchProps("createdAt"),
      render: (text) => (
        <span style={{ color: "black" }}>
          {moment(text).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      title: <span style={{ color: "black" }}>Created By</span>,
      dataIndex: "student",
      key: "student",
      render: (student) => (
        <div style={{ color: "black" }}>{student?.name || "N/A"}</div>
      ),
    },
    {
      title: <span style={{ color: "black" }}>Status</span>,
      dataIndex: "status",
      key: "status",
      render: (text) => <div style={{ color: "black" }}>{text || "N/A"}</div>,
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "action",
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            shape="circle"
            disabled={record.status === "answer"}
            icon={<InfoCircleOutlined />}
            onClick={() => openModal(record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure？"
            cancelText="No"
            okText="Yes"
            onConfirm={() => deleteTest(record._id)}
            icon={<DeleteOutlined style={{ color: "red" }} />}
          >
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <div className="admin-table-container">
      <div className="register-trainer-form-header">
        <Title
          level={4}
          style={{ color: "#fff", textAlign: "center", marginTop: -5 }}
        >
          Question Consultation
        </Title>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={ConsultationTabelData}
        size="medium"
        pagination={{ pageSize: 10 }}
        loading={loading}
        rowKey="_id"
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />
      <Modal
        open={isModelOpen}
        title={question.name}
        onCancel={closeModal}
        afterClose={closeModal}
        style={{ top: "20px", maxHeight: "80vh", overflow: "auto" }}
        width="80%"
        // destroyOnClose
        footer={null}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Typography className="queryText">
              {question.description}
            </Typography>
            {question?.questionImage && (
              <img
                src={apis.BASE_LOCAL_URL + question.questionImage}
                alt=""
                style={{ width: "400px" }}
              />
            )}
          </Col>
          <Col xs={24} md={12}>
            <Form layout="vertical" form={form}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Select learning outcome"
                    name="query"
                    rules={[
                      { required: true, message: "Please input your query!" },
                    ]}
                  >
                    <Input name="learningOutcomes" onChange={handleChange} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Select question topic"
                    name="topic"
                    rules={[
                      { required: true, message: "Please input your topic!" },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Level"
                      onSelect={(value) =>
                        handleTopicChange("questionTopic", { value })
                      }
                    >
                      {(question.subject === "Mathematics"
                        ? givenMathsTopics
                        : question.subject === "Science"
                        ? givenScienceTopics
                        : question.subject === "English"
                        ? givenEnglishTopics
                        : []
                      ).map((d) => (
                        <Option key={d.value} value={d.value}>
                          {d.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {file ? (
                    <Typography style={{ color: "black" }}>
                      {file.name}
                    </Typography>
                  ) : (
                    <label style={{ cursor: "pointer" }} className="fileUpload">
                      <img src={UploadIcon} alt="" />
                      <input
                        onChange={handleFileChange}
                        type="file"
                        accept="video/*"
                        style={{ width: "0%" }}
                      />
                    </label>
                  )}
                </Col>
              </Row>
              <div style={{ textAlign: "right" }}>
                <Button type="primary" onClick={handleSubmitResponse}>
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default QuestionConsultation;
